<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div id="vertical-flow">

                    <!-- TÍTULO -->
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("despesas") }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t("despesas") }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button 
                                v-if="permissao.create" 
                                class="save-btn" 
                                type="button" 
                                tag="button"
                                @click="$router.push({ name: 'des-despesa-new' })"
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-6">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>
                        <div class="column is-3">
                            <vss-select 
                                ref="motivodespesa" 
                                :options="motivoSelect"
                                v-model="motivoSelected" 
                                title="motivo-despesa" 
                                clearable 
                                :height="40"
                                @input="onMotivoChanged" 
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select 
                                ref="situacoes" 
                                :options="situacaoSelect"
                                v-model="situacaoSelected" 
                                mlLabels 
                                title="situacao" 
                                clearable 
                                @input="onSituacaoChanged"
                                :height="40" 
                            />
                        </div>
                    </div>

                    <!-- TABELA DE DESPESAS -->
                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table 
                            v-else 
                            :data="alldespesas" 
                            class="data-table"
                            backend-sorting
                            @sort="sortTable"
                        >
                            <b-table-column 
                                v-for="f in fields" 
                                :key="f.key + '-' + f.nome" 
                                :field="f.key"
                                :label="$t(f.key)" 
                                :width="f.key == 'obs' ? 400 : f.width" 
                                :sortable="f.sortable"
                                :visible="hideExcluir(f.key)" 
                                v-slot="props"
                                :class="{ 'excluir-field': f.key == 'excluir', }"
                            >
                                <div v-if="f.key == 'codigo'">
                                    <div v-if="situacaoSelected.id == 2 && parametrizacao.includes('A')">
                                        <router-link :to="{
                                            name: 'des-despesa-edit',
                                            params: {
                                                id: props.row[f.key],
                                            },
                                        }">
                                            <pre>{{ props.row[f.key] }}</pre>
                                        </router-link>
                                    </div>

                                    <div v-else >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </div>

                                </div>

                                <div v-else-if="f.key == 'data'">
                                    {{ props.row[f.key] | moment("L LT") }}
                                </div>

                                <div v-else-if="f.key == 'motivo-despesa'">
                                    {{ props.row.motivodespesa }}
                                </div>

                                <div v-else-if="f.key == 'valor'">
                                    {{ props.row[f.key] | decimal(null, true) }}
                                </div>

                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag 
                                        class="table-tag table-tag-full-width"
                                        :type="isStatusButtonType(props.row[f.key])"
                                        size="is-medium"
                                    >
                                        {{ $t(props.row[f.key].toLowerCase()) }}
                                    </b-tag>
                                </div>

                                <div v-else-if="
                                    f.key == 'excluir' && 
                                    permissao.delete && situacaoSelected.id == 2 && 
                                    parametrizacao.includes('D')
                                ">
                                    <b-button 
                                        type="is-danger" 
                                        icon-right="delete"
                                        @click="confirmExclusion(props.row)" 
                                        v-tippy 
                                        :title="$t('excluir')"
                                    />
                                </div>

                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>

                            </b-table-column>
                        </b-table>
                        <PaginationViewer 
                            class="mb-0" 
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows" 
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted" 
                            @change="updatePagination" 
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import DespesaService from "@/services/despesas/DespesaService";
import MotivoDespesaService from "@/services/despesas/MotivoDespesasService.js";
import ParametrizacaoService from "@/services/ParametrizacaoService";
// COMPONENTS
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import Message from '@/models/Message';

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("des-despesa") &&
            to.name != "des-despesa-list"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader
    },
    data() {
        return {
            rotaAninhada: false,
            service: new DespesaService(this.$http, this.$router),
            serviceMotivo: new MotivoDespesaService(this.$http, this.$router),
            serviceParametrizacao: new ParametrizacaoService(this.$http, this.$router),
            alldespesas: [],
            motivoSelect: [],
            motivoSelected: { iddespesa_motivo: 0, label: "TODOS" },
            situacaoSelect: [
                { paramQuery: "EXCLUIDO", label: "excluidos", id: 0 },
                { paramQuery: "FECHADO", label: "fechados", id: 1 },
                { paramQuery: "ABERTO", label: "abertos", id: 2 },
            ],
            situacaoSelected: { paramQuery: "ABERTO", label: "abertos", id: 2 },
            fields: [
                { key: "codigo", width: 55, sortable: true },
                { key: "data", width: null, sortable: true },
                { key: "motivo-despesa", width: null, sortable: false },
                { key: "empresa", width: null, sortable: false },
                { key: "valor", width: null, sortable: true },
                { key: 'situacao', width: 80, sortable: false },
                { key: 'excluir', width: 20, sortable: false }
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            valorScale: this.$store.state.empresas.data[0].valordecimalplaces,
            prefix: this.$store.state.empresas.data[0].simbolomonetario,
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            filters: {
                column: "datahora",
                order: "desc",
                queryFilter: "",
            },
            permissao: {},
            parametrizacao: "N",
        };
    },
    created() {
        this.rotaAninhada = (
            this.$route.name.includes("des-despesa") &&
            this.$route.name != "des-despesa-list"
        );

        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];

        this.permissao = this.hasPermissionAccess(
            "despesas",
            "despesas",
            "des-despesa"
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'despesas' },
            });
        } else {
            this.carregaParametrizacao();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarMotivos();
            this.carregarDados();
        }
    },
    methods: {
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            if(val == null) this.situacaoSelected = this.situacaoSelect[2];
            this.carregarDados();
        },
        onMotivoChanged(val) {
            if(val == null) this.motivoSelected = this.motivoSelect[0];
            this.carregarDados();
        },
        carregaParametrizacao() {
            this.serviceParametrizacao
                .getConfigByNomeIdusuario('DESPESA_ALTERADELETA', this.$store.state.user.id)
                .then(({ content }) => {
                    this.parametrizacao = content.valor;
                }).catch(e => {
                    console.warn('[DESPESA] Parametrização de altera/deleta despesa não está habilitada.');
                });
        },
        // Carregamento de despesas
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;

            let params = [
                this.isNull(this.filters.queryFilter) 
                    ? '.*' : this.filters.queryFilter, 
                this.situacaoSelected.paramQuery
            ];

            this.service
                .findAll(
                    this.motivoSelected.iddespesa_motivo,
                    this.filters.column,
                    this.filters.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    params
                )
                .then(this.mapItems)
                .then(value => {
                    this.alldespesas = value;
                    this.isEmpty = this.alldespesas.length <= 0;
                })
                .catch(e => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(_ => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map(despesa => {
                return {
                    codigo: despesa.iddespesa,
                    data: despesa.datahorainc,
                    situacao: despesa.situacao,
                    motivodespesa: despesa.despesamotivo.descricao,
                    empresa: despesa.empresa.nome,
                    valor: despesa.valor,
                };
            });
        },
        carregarMotivos() {
            this.serviceMotivo.findAllCombo("")
                .then(this.mapMotivos)
                .then(value => {
                    this.motivoSelect = value;
                    this.motivoSelect.unshift({ iddespesa_motivo: 0, label: "TODOS" })
                })
                .catch(error => {
                    console.log(error);
                    this.$root.msgs.push(new Message("error", 'msg-erro-busca-motivos', true));
                });
        },
        mapMotivos(body) {
            return body.content.map(motivo => {
                return {
                    iddespesa_motivo: motivo.iddespesa_motivo,
                    label: motivo.descricao,
                };
            });
        },
        // Exclusão de despesa
        confirmExclusion(row) {
            this.delete = row;
            let message = this.$t('msg-confirmacao-exclusao-n', { n: row.motivodespesa });
            this.$root.confirm({
                message: message,
                onConfirm: this.excluiRegistro,
                onCancel: this.removePrompt,
            });
        },
        excluiRegistro() {
            let despesa = {
                idusuariodel: this.$store.state.user.id,
                iddespesa: this.delete.codigo
            }
            this.service
                .updateSituacao(despesa)
                .then(_ => {
                    this.$root.msgs.push(new Message("success", 'msg-sucesso-ao-excluir-despesa', true))
                    this.carregarDados();
                })
                .catch(_ => {
                    this.$root.msgs.push(new Message("error", 'msg-erro-ao-excluir-despesa', true))
                })
        },
        removePrompt() {
            this.delete = null;
        },
        // Funções de utilidade
        onSearch(value) {
            // para a pesquisa por valor
            if(!this.isNull(value)) value = value.replace(/,/g, '.');
            this.filters.queryFilter = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        isStatusButtonType(status) {
            if (status == "ABERTO") return "is-warning";
            else if (status == "FECHADO") return "is-success";
            else if (status == "EXCLUIDO") return "is-danger";
        },
        hideExcluir(field) {
            if (this.parametrizacao.includes('D')) {
                return !(field == 'excluir' && this.situacaoSelected.id != 2);
            } else {
                return field != 'excluir';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
}
</style>